import arrayLikeToArray from "./arrayLikeToArray";
export default function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}


//////////////////
// WEBPACK FOOTER
// ../~/css-vendor/~/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
// module id = 2583
// module chunks = 121